<template>
  <div v-if="showPaintBrush" class="paint-brush" data-name="paint-brush">
    <div class="paint-brush-wrapper" data-name="paint-brush-wrapper">
      <div v-if="trayType === 'brush'" class="svg-wrapper" data-name="tray-icon" @click.stop="handleOpenMenu">
        <svg-icon name="paint-brush" class="tray-icon" />
      </div>

      <div v-if="trayType === 'close'" class="svg-wrapper" data-name="tray-icon" @click.stop="handleOpenMenu">
        <svg-icon name="paint-toggle" class="tray-icon" />
      </div>

      <div v-if="trayType === 'eraser'" class="svg-wrapper" data-name="tray-icon" @click.stop="handleOpenMenu">
        <svg-icon name="paint-eraser" class="tray-icon" />
      </div>

      <!-- 画布 -->
      <canvas
        v-if="showPaintBrushBoard"
        id="canvas"
        data-name="canvas"
        class="cursor1"
        width="500"
        height="500"
        @click="handleCanvasClick"
      />

      <!-- 顶部气泡框 -->
      <div v-if="showPop" class="pop-modal">
        <div class="pop-wrapper">
          <div class="pop-modal-content">
            <div v-for="(item, index) in contentList" :key="`${item}${index}`" class="content-item">
              {{ item }}
            </div>
          </div>

          <div class="pop-modal-button" @click="handleConfirm">好的，我知道了</div>
        </div>

        <svg-icon name="paint-down" class="modal-icon" />
      </div>

      <!-- 画笔操作栏 -->
      <div v-show="showPaintBrushMenu" class="actions-wrapper">
        <svg-icon name="paint-triangle" class="actions-triangle" />

        <div id="actions" class="actions">
          <!-- 画笔 -->
          <div
            id="brush-wrapper"
            :class="['item', activeType === 'brush' ? 'brush-icon-active' : '']"
            @click.stop="handleBrush"
            @mouseover="e => handleMouseOver(e, 'brush')"
            @mouseout="e => handleMouseOut(e, 'brush')"
          >
            <svg-icon id="brush" class="icon" :name="brushName" font-size="18" />
            <div :class="['item-name']">画笔</div>
            <a-divider />
          </div>

          <!-- 橡皮擦 -->
          <div
            id="eraser-wrapper"
            :class="['item', activeType === 'eraser' ? 'eraser-icon-active' : '']"
            @click.stop="handleEraser"
            @mouseover="e => handleMouseOver(e, 'eraser')"
            @mouseout="e => handleMouseOut(e, 'eraser')"
          >
            <svg-icon id="eraser" class="icon" :name="eraserName" font-size="18" />
            <div :class="['item-name', !activeEraserAndClear ? 'not-active-text' : '']">橡皮</div>
            <a-divider />
          </div>

          <!-- 清空画板 -->
          <div
            id="clear-wrapper"
            :class="['item', activeType === 'clear' ? 'clear-icon-active' : '']"
            @click.stop="handleClear('0')"
            @mouseover="e => handleMouseOver(e, 'clear')"
            @mouseout="e => handleMouseOut(e, 'clear')"
          >
            <svg-icon id="clear" class="icon" :name="clearName" font-size="18" />
            <div :class="['item-name', !activeEraserAndClear ? 'not-active-text' : '']">清空</div>
            <a-divider />
          </div>

          <!-- 退出画板 -->
          <div
            id="quit-wrapper"
            :class="['item', activeType === 'quit' ? 'quit-icon-active' : '']"
            @click.stop="handleQuit"
            @mouseover="e => handleMouseOver(e, 'quit')"
            @mouseout="e => handleMouseOut(e, 'quit')"
          >
            <svg-icon id="quit" class="icon" :name="quitName" font-size="18" />
            <div :class="['item-name']">退出</div>
          </div>
        </div>
      </div>

      <!-- 画笔颜色栏 -->
      <div v-if="showPaintBrushColorSelect" class="colors-select-wrapper">
        <div class="colors-select">
          <!-- 笔触选择 -->
          <div class="brush-stroke" @click.stop="handleStroke">
            <div class="stroke-wrapper" data-name="small">
              <div :class="['stroke-small', selectedStrokeType === 'small' ? 'stroke-active' : '']" data-name="small" />
            </div>

            <div class="stroke-wrapper" data-name="default">
              <div
                :class="['stroke-default', selectedStrokeType === 'default' ? 'stroke-active' : '']"
                data-name="default"
              />
            </div>

            <div class="stroke-wrapper" data-name="large">
              <div :class="['stroke-large', selectedStrokeType === 'large' ? 'stroke-active' : '']" data-name="large" />
            </div>
          </div>

          <a-divider />

          <!-- 颜色选择 -->
          <div class="brush-color">
            <div id="white" :class="['color-item', 'white']" @click.stop="handleWhite">
              <div v-if="selectedColorType === '#FFFFFF'" class="selected-color-icon" />
            </div>
            <div id="blue" :class="['color-item', 'blue']" @click.stop="handleBlue">
              <div v-if="selectedColorType === '#1976FF'" class="selected-color-icon" />
            </div>
            <div id="red" :class="['color-item', 'red']" @click.stop="handleRed">
              <div v-if="selectedColorType === '#FF3C30'" class="selected-color-icon" />
            </div>
          </div>

          <div class="brush-color">
            <div id="yellow" :class="['color-item', 'yellow']" @click.stop="handleYellow">
              <div v-if="selectedColorType === '#FFA516'" class="selected-color-icon" />
            </div>
            <div id="green" :class="['color-item', 'green']" @click.stop="handleGreen">
              <div v-if="selectedColorType === '#1DC060'" class="selected-color-icon" />
            </div>
            <div id="orange" :class="['color-item', 'orange']" @click.stop="handleOrange">
              <div v-if="selectedColorType === '#A16222'" class="selected-color-icon" />
            </div>
          </div>
        </div>

        <svg-icon name="paint-muti" class="colors-select-muti" />

        <!-- <div class="right-triangle" /> -->
      </div>
    </div>
  </div>
</template>

<script>
// import Hammer from 'hammerjs'

export default {
  name: 'PaintBrush',
  props: {},
  data() {
    return {
      brush: null, // 画笔dom
      eraser: null, // 橡皮擦dom
      canvas: null, // 画布
      ctx: null, // 画布上下文
      EraserEnabled: false, // 控制橡皮擦开启
      showPaintBrush: false, // 开启画笔功能
      showPaintBrushMenu: false, // 显示画笔功能操作栏
      showPaintBrushColorSelect: false, // 显示画笔颜色、笔触选择
      showPaintBrushBoard: false, // 显示画布
      activeEraserAndClear: false, // 橡皮和清空icon处于禁用状态（默认）
      selectedStrokeType: 'default', // 笔触类型（中等）
      selectedColorType: '#FF3C30', // 笔触颜色（默认红色）
      trayType: 'brush', // 画笔托盘icon类型
      strokeLineWidth: 5, // 笔触粗细（默认中等）
      activeType: 'brush', // 当前点击的icon
      brushName: 'paint-brush', // 画笔名称
      eraserName: 'paint-eraser-gray', // 橡皮擦名称
      clearName: 'paint-clear-gray', // 清空名称
      quitName: 'paint-quit', // 退出名称
      cancel: false, // 是否点击了退出取消
      contentList: ['1.点击弹出设置', '2.拖拽移动位置'],
      showPop: false,
      isMoving: false // 是否正在移动
    }
  },
  beforeDestroy() {
    this.$emit('close')
  },
  methods: {
    // 打开画笔
    open(openedBrushPop) {
      // 打开画笔托盘
      this.showPaintBrush = true
      // 开启画板
      this.showPaintBrushBoard = true
      // 打开气泡框，弹出过一次就不再弹出
      if (!openedBrushPop) {
        this.showPop = true
      }
      // 画板初始化
      setTimeout(() => {
        this.init()
      }, 100)
    },

    // 关闭画笔
    close() {
      this.showPaintBrush = false
    },

    // 打开画笔功能操作栏
    handleOpenMenu() {
      if (this.isMoving) return
      this.showPaintBrushMenu = !this.showPaintBrushMenu

      // 收起笔触粗细、线条颜色选择栏
      if (this.showPaintBrushMenu && this.activeType === 'brush') {
        if (this.activeEraserAndClear) {
          this.clearName = 'paint-clear'
        } else {
          this.clearName = 'paint-clear-gray'
        }

        this.quitName = 'paint-quit'
        // 更换画笔激活icon
        this.brushName = 'paint-brush-active'

        sessionStorage.setItem('activeType', 'brush')

        this.showPaintBrushColorSelect = true
      } else {
        this.showPaintBrushColorSelect = false
      }

      let currentActiveType = sessionStorage.getItem('activeType') ?? 'brush'

      if ((currentActiveType === 'clear' || currentActiveType === 'quit') && this.trayType !== 'eraser') {
        if (this.activeEraserAndClear) {
          this.clearName = 'paint-clear'
        } else {
          this.clearName = 'paint-clear-gray'
        }

        this.quitName = 'paint-quit'
        // 更换画笔激活icon
        this.brushName = 'paint-brush-active'

        sessionStorage.setItem('activeType', 'brush')

        if (currentActiveType !== 'clear') {
          this.showPaintBrushColorSelect = true
        }

        if (this.showPaintBrushMenu && currentActiveType === 'clear') {
          this.showPaintBrushColorSelect = true
        }

        if (this.showPaintBrushMenu && currentActiveType === 'quit') {
          this.showPaintBrushColorSelect = true
        }

        currentActiveType = 'brush'
      }

      // 当点击退出，点击退出的取消时，同时点击了画笔icon托盘收起，画笔颜色、笔触颜色选择栏收起
      if (this.cancel && this.activeType !== 'brush' && !this.showPaintBrushMenu) {
        this.showPaintBrushColorSelect = false
      }

      // 默认取上次激活的icon类型
      this.activeType = currentActiveType

      // 展开笔触粗细、线条颜色选择栏
      // this.showPaintBrushColorSelect = true

      // 画笔托盘icon变为close
      if (this.showPaintBrushMenu) {
        this.trayType = 'close'
      } else {
        // 上一次最后点击时画笔托盘icon类型
        const trayType = sessionStorage.getItem('trayType')
        this.trayType = trayType ?? 'brush'
      }

      // 画布已挂载，禁止二次挂载
      // if (this.showPaintBrushBoard) {
      //   return
      // }

      // 初始化画板及操作栏
      // 挂载画布
      // this.showPaintBrushBoard = true
      // setTimeout(() => {
      //   this.init()
      // }, 100)
    },

    // 画布初始化
    init() {
      this.brush = document.getElementById('brush')
      this.eraser = document.getElementById('eraser')

      this.canvas = document.getElementById('canvas')

      if (this.canvas === null) return

      this.ctx = this.canvas?.getContext('2d')

      // 画板控制开关
      let painting = false

      // 第一个点坐标
      let startPoint = { x: undefined, y: undefined }

      // 初始化画布大小
      this.wh()

      const that = this

      // === 画笔触屏画画调试部分 (留存记录) start ===
      // console.log('手势 - 是否支持触屏事件 - document',
      //   document.body.ontouchstart,
      //   document.documentElement.ontouchstart,
      //   document.body.ontouchmove,
      //   document.documentElement.ontouchmove,
      //   document.body.ontouchend,
      //   document.documentElement.ontouchend
      // )

      // console.log('手势 - 是否支持触屏事件 - canvas',
      //   this.canvas.ontouchstart,
      //   this.canvas.ontouchstart,
      //   this.canvas.ontouchmove,
      //   this.canvas.ontouchmove,
      //   this.canvas.ontouchend,
      //   this.canvas.ontouchend
      // )

      // console.log('鼠标 - 是否支持滑动事件',
      //   document.body.onmousedown,
      //   document.documentElement.onmousedown,
      //   document.body.onmousemove,
      //   document.documentElement.onmousemove,
      //   document.body.onmouseup,
      //   document.documentElement.onmouseup
      // )

      // console.log('Electron进程间通信',
      //   window.electron.ipcRenderer,
      //   window.electron.ipcRenderer.on
      // )

      // === 模拟移动端触屏 start ===
      // window.electron.ipcRenderer.send('openSimulateTouch', { enable: true })

      this.canvas.addEventListener('touchstart', e => {
        // console.log('canvas监听开始触摸', e)

        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        painting = true
        if (that.EraserEnabled) {
          // 当选择橡皮擦时，画笔托盘icon从缓存中取，缓存没有，表示初始化，取默认值eraser
          const currentTrayType = sessionStorage.getItem('trayType') ?? 'eraser'
          that.trayType = currentTrayType
          // 当选择橡皮擦时收起画笔功能栏、线条颜色选择栏
          that.showPaintBrushColorSelect = false
          that.showPaintBrushMenu = false

          that.ctx.clearRect(x - 15, y - 15, 30, 30)
        }
        startPoint = { x: x, y: y }
      })

      this.canvas.addEventListener('touchmove', e => {
        // console.log('canvas监听移动触摸', e)

        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        const newPoint = { x: x, y: y }
        if (painting) {
          if (that.EraserEnabled) {
            that.ctx.clearRect(x - 15, y - 15, 30, 30)
          } else {
            that.drawLine(startPoint.x, startPoint.y, newPoint.x, newPoint.y)
          }
          startPoint = newPoint
        }
      })

      this.canvas.addEventListener('touchend', e => {
        // console.log('canvas监听结束触摸', e)

        painting = false
      })

      // 监听触摸事件
      // window.electron.ipcRenderer.on('touch-event', (e, type, touch) => {
      //   console.log(`Touch ${type} at ${touch.location.x}, ${touch.location.y}`)

      //   if (type === 'touch-start') {
      //     console.log('开始触摸屏', e, touch)

      //     const x = e.touches[0].clientX
      //     const y = e.touches[0].clientY
      //     painting = true
      //     if (that.EraserEnabled) {
      //       // 当选择橡皮擦时，画笔托盘icon从缓存中取，缓存没有，表示初始化，取默认值eraser
      //       const currentTrayType = sessionStorage.getItem('trayType') ?? 'eraser'
      //       that.trayType = currentTrayType
      //       // 当选择橡皮擦时收起画笔功能栏、线条颜色选择栏
      //       that.showPaintBrushColorSelect = false
      //       that.showPaintBrushMenu = false

      //       that.ctx.clearRect(x - 15, y - 15, 30, 30)
      //     }
      //     startPoint = { x: x, y: y }
      //   } else if (type === 'touch-move') {
      //     console.log('触摸屏移动', e, touch)

      //     const x = e.touches[0].clientX
      //     const y = e.touches[0].clientY
      //     const newPoint = { x: x, y: y }
      //     if (painting) {
      //       if (that.EraserEnabled) {
      //         that.ctx.clearRect(x - 15, y - 15, 30, 30)
      //       } else {
      //         that.drawLine(startPoint.x, startPoint.y, newPoint.x, newPoint.y)
      //       }
      //       startPoint = newPoint
      //     }
      //   } else if (type === 'touch-end') {
      //     console.log('触摸屏结束', e, touch)

      //     painting = false
      //   }
      // })

      // const mn = new Hammer.Manager(this.canvas)

      // const Swipe = new Hammer.Swipe()

      // mn.add(Swipe)

      // mn.on('swipe', function(e) {
      //   console.log('使用hammerjs模拟触屏', e)
      // })

      // 通过指针事件监听
      this.canvas.onpointerdown = e => {
        // console.log('通过指针事件监听触屏 - down', e)
      }

      this.canvas.onpointermove = e => {
        // console.log('通过指针事件监听触屏 - move', e)
      }

      this.canvas.onpointerup = e => {
        // console.log('通过指针事件监听触屏 - up', e)
      }
      // === 画笔触屏画画调试部分 (留存记录) end ===

      // 特性检测
      if (document.body.ontouchstart !== undefined) {
        // 触屏设备
        that.canvas.ontouchstart = function (e) {
          // [0]表示touch第一个触碰点
          const x = e.touches[0].clientX
          const y = e.touches[0].clientY
          painting = true
          if (that.EraserEnabled) {
            // 当选择橡皮擦时，画笔托盘icon从缓存中取，缓存没有，表示初始化，取默认值eraser
            const currentTrayType = sessionStorage.getItem('trayType') ?? 'eraser'
            that.trayType = currentTrayType
            // 当选择橡皮擦时收起画笔功能栏、线条颜色选择栏
            that.showPaintBrushColorSelect = false
            that.showPaintBrushMenu = false

            that.ctx.clearRect(x - 15, y - 15, 30, 30)
          }
          startPoint = { x: x, y: y }
        }

        that.canvas.ontouchmove = function (e) {
          const x = e.touches[0].clientX
          const y = e.touches[0].clientY
          const newPoint = { x: x, y: y }
          if (painting) {
            if (that.EraserEnabled) {
              that.ctx.clearRect(x - 15, y - 15, 30, 30)
            } else {
              that.drawLine(startPoint.x, startPoint.y, newPoint.x, newPoint.y)
            }
            startPoint = newPoint
          }
        }

        that.canvas.ontouchend = function () {
          painting = false
        }
      } else {
        // 非触屏设备
        // 按下鼠标(mouse)
        // 鼠标点击事件（onmousedown）
        that.canvas.onmousedown = function (e) {
          const x = e.offsetX
          const y = e.offsetY
          painting = true
          if (that.EraserEnabled) {
            // 当选择橡皮擦时，画笔托盘icon从缓存中取，缓存没有，表示初始化，取默认值eraser
            const currentTrayType = sessionStorage.getItem('trayType') ?? 'eraser'
            that.trayType = currentTrayType
            // 当选择橡皮擦时收起画笔功能栏、线条颜色选择栏
            that.showPaintBrushColorSelect = false
            that.showPaintBrushMenu = false

            that.ctx.clearRect(x - 15, y - 15, 30, 30)
          }
          startPoint = { x: x, y: y }
        }

        // 滑动鼠标
        // 鼠标滑动事件（onmousemove）
        that.canvas.onmousemove = function (e) {
          const x = e.offsetX
          const y = e.offsetY
          const newPoint = { x: x, y: y }
          if (painting) {
            if (that.EraserEnabled) {
              that.ctx.clearRect(x - 15, y - 15, 30, 30)
            } else {
              that.drawLine(startPoint.x, startPoint.y, newPoint.x, newPoint.y)
            }
            startPoint = newPoint
          }
        }

        // 松开鼠标
        // 鼠标松开事件（onmouseup)
        that.canvas.onmouseup = function () {
          painting = false
        }
      }
    },

    // 点与点之间连接
    drawLine(xStart, yStart, xEnd, yEnd) {
      // 开始划线时，画笔托盘icon从缓存中取，缓存没有，表示初始化，取默认值brush
      const currentTrayType = sessionStorage.getItem('trayType') ?? 'brush'
      this.trayType = currentTrayType
      // 开始划线收起画笔功能栏、线条颜色选择栏
      this.showPaintBrushMenu = false
      this.showPaintBrushColorSelect = false
      // 当画笔开始画画时，橡皮和清空icon处于启用状态
      this.activeEraserAndClear = true
      this.eraserName = 'paint-eraser'
      this.clearName = 'paint-clear'
      // 开始绘制路径
      this.ctx.beginPath()
      // 线条颜色
      this.ctx.strokeStyle = this.selectedColorType
      // 线宽
      this.ctx.lineWidth = this.strokeLineWidth
      // 线条接合处为圆角
      this.ctx.lineJoin = 'round'
      this.ctx.lineCap = 'round'
      // 起始位置
      this.ctx.moveTo(xStart, yStart)
      // 停止位置
      this.ctx.lineTo(xEnd, yEnd)
      // 描绘线路
      this.ctx.stroke()
      // 结束绘制
      this.ctx.closePath()
    },

    // canvas与屏幕宽高一致
    wh() {
      const pageWidth = document.documentElement.clientWidth
      const pageHeight = document.documentElement.clientHeight
      this.canvas.width = pageWidth
      this.canvas.height = pageHeight
    },

    // 点击画板时触发
    handleCanvasClick() {
      // 关闭颜色、笔触选择
      this.showPaintBrushColorSelect = false
    },

    // 橡皮擦
    handleEraser() {
      // 关闭颜色、笔触选择
      this.showPaintBrushColorSelect = false

      // 禁用橡皮擦和清空时，禁止点击
      if (!this.activeEraserAndClear) return

      // 启用橡皮擦
      this.EraserEnabled = true

      // 画笔托盘icon变为橡皮擦icon
      if (!this.showPaintBrushMenu) {
        this.trayType = 'eraser'
      }

      // 将画笔托盘icon存储在sessionStorage
      sessionStorage.setItem('trayType', 'eraser')

      // 当前点击的icon
      this.activeType = 'eraser'
      sessionStorage.setItem('activeType', this.activeType)

      // 更换橡皮擦激活icon
      // 处理其它3个icon
      if (this.activeEraserAndClear) {
        this.eraserName = 'paint-eraser-active'
        this.clearName = 'paint-clear'
      } else {
        this.eraserName = 'paint-eraser-gray'
        this.clearName = 'paint-clear-gray'
      }
      this.brushName = 'paint-brush'
      this.quitName = 'paint-quit'

      // 激活橡皮擦样式
      this.eraser.classList.add('active')

      // 移除画笔样式
      this.brush.classList.remove('active')

      // 鼠标更换为橡皮擦icon
      this.canvas.classList.add('xiangpica')

      // 收起画笔功能栏
      // this.showPaintBrushMenu = false
    },

    // 画笔
    handleBrush() {
      // 禁用橡皮擦
      this.EraserEnabled = false

      // 点击画笔时，收起画笔功能栏、线条颜色选择栏
      // if (this.showPaintBrushColorSelect) {
      //   this.showPaintBrushColorSelect = false
      // }

      this.showPaintBrushColorSelect = !this.showPaintBrushColorSelect

      // 画笔托盘icon变为画笔icon
      if (!this.showPaintBrushMenu) {
        this.trayType = 'brush'
      }

      // 将画笔托盘icon存储在sessionStorage
      sessionStorage.setItem('trayType', 'brush')

      // 当前点击的icon
      this.activeType = 'brush'
      sessionStorage.setItem('activeType', this.activeType)

      // 更换画笔激活icon
      this.brushName = 'paint-brush-active'

      // 处理其它3个icon
      if (this.activeEraserAndClear) {
        this.eraserName = 'paint-eraser'
        this.clearName = 'paint-clear'
      } else {
        this.eraserName = 'paint-eraser-gray'
        this.clearName = 'paint-clear-gray'
      }
      this.quitName = 'paint-quit'

      this.brush.classList.add('active')
      this.eraser.classList.remove('active')
      this.canvas.classList.remove('xiangpica')

      // 开启颜色、笔触选择
      // this.showPaintBrushColorSelect = true
    },

    // 清屏
    handleClear(type = '0') {
      // 关闭颜色、笔触选择
      this.showPaintBrushColorSelect = false

      // 禁用橡皮擦和清空时，禁止点击
      if (!this.activeEraserAndClear) return

      this.clearName = 'paint-clear-active'

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

      // 退出画笔不提示
      if (type === '0') {
        this.$message.success('画板清空成功')
      }

      // 清屏结束将画笔托盘icon变为画笔icon
      if (!this.showPaintBrushMenu) {
        this.trayType = 'brush'
      }

      // 将画笔托盘icon存储在sessionStorage
      sessionStorage.setItem('trayType', 'brush')

      // 当前点击的icon清空
      this.activeType = 'clear'
      sessionStorage.setItem('activeType', this.activeType)

      // 禁用橡皮擦
      this.EraserEnabled = false

      // 当画板清空时，橡皮擦和清空icon处于禁用状态
      this.activeEraserAndClear = false
      this.clearName = 'paint-clear-gray'

      // 处理其它3个icon
      this.brushName = 'paint-brush'
      this.eraserName = 'paint-eraser-gray'
      this.quitName = 'paint-quit'

      // 移除鼠标橡皮擦icon
      this.canvas.classList.remove('xiangpica')

      this.cancel = false

      // 收起画笔功能栏
      // this.showPaintBrushMenu = false
    },

    // 关闭画板
    handleQuit() {
      // 跟换退出激活icon
      this.quitName = 'paint-quit-active'

      // 处理其它3个icon
      this.brushName = 'paint-brush'
      if (this.activeEraserAndClear) {
        this.eraserName = 'paint-eraser'
        this.clearName = 'paint-clear'
      } else {
        this.eraserName = 'paint-eraser-gray'
        this.clearName = 'paint-clear-gray'
      }

      // 当前点击的icon类型
      this.activeType = 'quit'
      sessionStorage.setItem('activeType', this.activeType)

      // 收起线条、笔触颜色选择栏
      this.showPaintBrushColorSelect = false

      // 清屏
      this.handleClear('1')

      // 关闭颜色、笔触选择
      this.showPaintBrushColorSelect = false

      // 收起画笔功能栏
      this.showPaintBrushMenu = false

      // 卸载画布
      this.showPaintBrushBoard = false

      // 卸载画笔
      this.showPaintBrush = false

      // 重置画笔托盘icon
      this.trayType = 'brush'

      // 退出后，激活icon为画笔
      this.activeType = 'brush'

      // 卸载画笔时，移除存储在sessionStorage的画笔icon类型
      sessionStorage.removeItem('trayType')

      // 卸载画笔时，移除存储在sessionStorage的激活icon类型
      sessionStorage.removeItem('activeType')

      this.cancel = false

      // 卸载画笔的回调
      this.$emit('close')

      // window.electron.ipcRenderer.send('closeSimulateTouch', { enable: true })

      // const that = this
      // this.$confirm({
      //   title: '是否确认退出画笔?',
      //   maskClosable: true,
      //   okText: '确认',
      //   cancelText: '取消',
      //   centered: true,
      //   onOk() {
      //     // 清屏
      //     that.handleClear('1')

      //     // 关闭颜色、笔触选择
      //     that.showPaintBrushColorSelect = false

      //     // 收起画笔功能栏
      //     that.showPaintBrushMenu = false

      //     // 卸载画布
      //     that.showPaintBrushBoard = false

      //     // 卸载画笔
      //     that.showPaintBrush = false

      //     // 重置画笔托盘icon
      //     that.trayType = 'brush'

      //     // 退出后，激活icon为画笔
      //     that.activeType = 'brush'

      //     // 卸载画笔时，移除存储在sessionStorage的画笔icon类型
      //     sessionStorage.removeItem('trayType')

      //     // 卸载画笔时，移除存储在sessionStorage的激活icon类型
      //     sessionStorage.removeItem('activeType')

      //     that.cancel = false

      //     // 卸载画笔的回调
      //     that.$emit('close')
      //   },
      //   onCancel() {
      //     that.cancel = true
      //   }
      // })
    },

    // 保存canvas画布到本地
    handleSave() {
      const url = this.canvas.toDataURL('image/jpg')
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = '草稿纸'
      a.target = '_blank'
      a.click()
    },

    // 笔触选择时触发
    handleStroke(e) {
      let lineWidth = 5
      const name = e.target.dataset?.name ?? 'default'

      switch (name) {
        case 'small':
          lineWidth = 2
          this.selectedStrokeType = 'small'
          break
        case 'default':
          lineWidth = 5
          this.selectedStrokeType = 'default'
          break
        case 'large':
          lineWidth = 11
          this.selectedStrokeType = 'large'
          break
        default:
          break
      }

      this.strokeLineWidth = lineWidth
    },

    // 画笔颜色及鼠标样式
    handleWhite() {
      this.ctx.strokeStyle = '#FFFFFF'
      this.selectedColorType = '#FFFFFF'

      this.canvas.classList.add('cursor1')
      this.canvas.classList.remove('cursor2')
      this.canvas.classList.remove('cursor3')
      this.canvas.classList.remove('cursor4')
      this.canvas.classList.remove('cursor5')
      this.canvas.classList.remove('cursor6')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    handleBlue() {
      this.ctx.strokeStyle = '#1976FF'
      this.selectedColorType = '#1976FF'

      this.canvas.classList.add('cursor2')
      this.canvas.classList.remove('cursor1')
      this.canvas.classList.remove('cursor3')
      this.canvas.classList.remove('cursor4')
      this.canvas.classList.remove('cursor5')
      this.canvas.classList.remove('cursor6')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    handleRed() {
      this.ctx.strokeStyle = '#FF3C30'
      this.selectedColorType = '#FF3C30'

      this.canvas.classList.add('cursor3')
      this.canvas.classList.remove('cursor1')
      this.canvas.classList.remove('cursor2')
      this.canvas.classList.remove('cursor4')
      this.canvas.classList.remove('cursor5')
      this.canvas.classList.remove('cursor6')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    handleYellow() {
      this.ctx.strokeStyle = '#FFA516'
      this.selectedColorType = '#FFA516'

      this.canvas.classList.add('cursor4')
      this.canvas.classList.remove('cursor1')
      this.canvas.classList.remove('cursor2')
      this.canvas.classList.remove('cursor3')
      this.canvas.classList.remove('cursor5')
      this.canvas.classList.remove('cursor6')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    handleGreen() {
      this.ctx.strokeStyle = '#1DC060'
      this.selectedColorType = '#1DC060'

      this.canvas.classList.add('cursor5')
      this.canvas.classList.remove('cursor1')
      this.canvas.classList.remove('cursor2')
      this.canvas.classList.remove('cursor3')
      this.canvas.classList.remove('cursor4')
      this.canvas.classList.remove('cursor6')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    handleOrange() {
      this.ctx.strokeStyle = '#A16222'
      this.selectedColorType = '#A16222'

      this.canvas.classList.add('cursor6')
      this.canvas.classList.remove('cursor1')
      this.canvas.classList.remove('cursor2')
      this.canvas.classList.remove('cursor3')
      this.canvas.classList.remove('cursor4')
      this.canvas.classList.remove('cursor5')
      this.canvas.classList.remove('xiangpica')
      this.EraserEnabled = false
      this.eraser.classList.remove('active')
    },

    // 鼠标hover移入
    handleMouseOver(e, type) {
      const dom = document.getElementById(`${type}-wrapper`)
      switch (type) {
        case 'brush':
          dom.classList.add('brush-icon-hover')
          this.brushName = 'paint-brush-active'
          break
        case 'eraser':
          if (this.activeEraserAndClear) {
            dom.classList.add('eraser-icon-hover')
            this.eraserName = 'paint-eraser-active'
          } else {
            this.eraserName = 'paint-eraser-gray'
          }
          break
        case 'clear':
          if (this.activeEraserAndClear) {
            dom.classList.add('clear-icon-hover')
            this.clearName = 'paint-clear-active'
          } else {
            this.clearName = 'paint-clear-gray'
          }
          break
        case 'quit':
          dom.classList.add('quit-icon-hover')
          this.quitName = 'paint-quit-active'
          break
      }
    },

    // 鼠标hover移出
    handleMouseOut(e, type) {
      const dom = document.getElementById(`${type}-wrapper`)
      switch (type) {
        case 'brush':
          dom.classList.remove('brush-icon-hover')

          if (this.activeType !== 'brush') {
            this.brushName = 'paint-brush'
          }
          break
        case 'eraser':
          if (this.activeEraserAndClear) {
            dom.classList.remove('eraser-icon-hover')

            if (this.activeType !== 'eraser') {
              this.eraserName = 'paint-eraser'
            }
          } else {
            dom.classList.remove('eraser-icon-hover')
            this.eraserName = 'paint-eraser-gray'
          }
          break
        case 'clear':
          if (this.activeEraserAndClear) {
            dom.classList.remove('clear-icon-hover')

            if (this.activeType !== 'clear') {
              this.clearName = 'paint-clear'
            }
          } else {
            this.clearName = 'paint-clear-gray'
          }
          break
        case 'quit':
          dom.classList.remove('quit-icon-hover')

          if (this.activeType !== 'quit') {
            this.quitName = 'paint-quit'
          }
          break
      }
    },

    // 关闭气泡框
    handleConfirm() {
      this.showPop = false
    }
  }
}
</script>

<style scoped lang="scss">
.paint-brush {
  position: fixed;
  bottom: 50vh;
  right: 54px;
  width: 56px;
  height: 56px;
  z-index: 10001;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.8) 100%);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  user-select: none;

  .paint-brush-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .svg-wrapper {
      width: 56px;
      height: 56px;
      z-index: 10001;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 13px;
      border-radius: 50%;

      // 画笔托盘icon
      .tray-icon {
        width: 1.8rem;
        height: 1.8rem;
        color: #101010;
        z-index: 10001;
      }
    }

    // 气泡框
    .pop-modal {
      position: absolute;
      top: -122px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .pop-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-radius: 12px;
        background: rgba(255, 255, 255);
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);

        .pop-modal-content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: max-content;
          padding-bottom: 6px;
          padding: 10px 10px 3px 10px;

          .content-item {
            font-family:
              PingFangSC,
              PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            text-align: left;
            font-style: normal;
          }
        }

        .pop-modal-button {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-family:
            PingFangSC,
            PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #1976ff;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          width: 100%;
          padding: 7px 10px 10px 10px;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;

          &:hover {
            background: #ebedf4;
          }

          &:active {
            background: #ebedf4;
          }
        }
      }

      .modal-icon {
        width: 15px;
        height: 6px;
      }
    }

    // 功能区
    .actions-wrapper {
      position: absolute;
      top: 66px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .actions-triangle {
        width: 18px;
        height: 10px;
      }

      .actions {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: #ffffff;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.14);
        border-radius: 12px;
        padding: 6px;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          padding: 5px 11px 0 11px;

          .icon {
            width: 1.7rem;
            height: 1.7rem;
            margin: 8px 0 4px 0;
            &:hover {
              color: #1976ff;
            }
          }

          .item-name {
            font-size: 15px;
            font-weight: 400;
            text-align: center;
            width: max-content;
            margin-bottom: 8px;
          }

          .ant-divider-horizontal {
            margin: 0 !important;
          }
        }
      }
    }

    // 画板
    #canvas {
      position: fixed;
      top: 0;
      left: 0;
      display: block;
      overflow: hidden;
      z-index: 9999;
      background: rgba(0, 0, 0, 0);
    }

    .colors-select-wrapper {
      position: absolute;
      top: 75px;
      right: 50px;
      z-index: 9999;
      display: flex;
      flex-direction: row;
      align-items: center;

      // 笔触、颜色选择
      .colors-select {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        padding: 12px;
        width: max-content;
        // width: 97px;
        background: linear-gradient(#e8f1ff 0%, #f6f6f6 100%);
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.08);
        border-radius: 14px;
        border: 2px solid #ffffff;

        // 笔触选择
        .brush-stroke {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          width: 100%;

          .stroke-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 30px;
            background: transparent;
            border-radius: 4px;

            &:hover {
              width: 36px;
              height: 30px;
              background: rgba(0, 0, 0, 0.05);
              border-radius: 4px;
            }

            .stroke-small {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.15);
            }

            .stroke-default {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.15);
            }

            .stroke-large {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.15);
            }

            .stroke-active {
              background: #000000;
            }
          }
        }
      }

      .ant-divider-horizontal {
        margin: 0 !important;
      }

      // 颜色选择
      .brush-color {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 12px;

        .color-item {
          width: 36px;
          height: 30px;
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;

          .selected-color-icon {
            width: 16px;
            height: 16px;
            background: url('@/assets/paint-brush/selected-color-icon.svg');
          }
        }

        .white {
          background: #ffffff;
        }

        .blue {
          background: #1976ff;
        }

        .red {
          background: #ff3c30;
        }

        .yellow {
          background: #ffa516;
        }

        .green {
          background: #1dc060;
        }

        .orange {
          background: #a16222;
        }
      }

      .colors-select-muti {
        width: 1em;
        height: 62px;
        margin-right: 10px;
        margin-top: -45px;
      }

      // 右边三角形
      .right-triangle {
        position: relative;
        width: 0;
        height: 0;
        border: 30px solid transparent;
        border-left-color: #bbbbbb;
      }

      .right-triangle::before {
        content: '';
        position: absolute;
        left: -29.5px;
        top: -27px;
        width: 0;
        height: 0;
        border: 27px solid transparent;
        border-left-color: #ffffff;
      }
    }
  }
}

.not-active-text {
  color: #c8c8c8 !important;
}

.brush-icon-active {
  color: #1976ff !important;
  background: linear-gradient(#f6f6f6 0%, #e8f1ff 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.eraser-icon-active {
  color: #1dc060 !important;
  background: linear-gradient(#f6f6f6 0%, #e8f9ef 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.clear-icon-active {
  color: #ff3c30 !important;
  background: linear-gradient(rgba(241, 241, 241, 0.8) 0%, #ffebea 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.quit-icon-active {
  color: #ffa516 !important;
  background: linear-gradient(#f6f6f6 0%, #fff6e7 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.brush-icon-hover {
  color: #1976ff !important;
  background: linear-gradient(#f6f6f6 0%, #e8f1ff 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.eraser-icon-hover {
  color: #1dc060 !important;
  background: linear-gradient(#f6f6f6 0%, #e8f9ef 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.clear-icon-hover {
  color: #ff3c30 !important;
  background: linear-gradient(rgba(241, 241, 241, 0.8) 0%, #ffebea 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

.quit-icon-hover {
  color: #ffa516 !important;
  background: linear-gradient(#f6f6f6 0%, #fff6e7 100%);
  border-radius: 8px;
  padding: 8px 11px 0 11px;
}

// 白色
.cursor1 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 蓝色
.cursor2 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 红色
.cursor3 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 黄色
.cursor4 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 绿色
.cursor5 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 橙色
.cursor6 {
  cursor:
    url('@/icons/svg/paint-brush.svg') 8 20,
    auto !important;
}
// 橡皮擦
.xiangpica {
  cursor:
    url('@/assets/paint-brush/xiangpica.svg') 8 20,
    auto !important;
}
</style>
